import type { LoyaltyTier, ProgramSettings } from '@/types/settings';

export const defaultProgram: ProgramSettings = {
  programName: 'LoyaltyBridge Rewards',
  pointsPerCurrency: 10,
  signupBonus: 200,
  redemptionPolicy: 'manual_review',
  defaultTier: 'Starter',
};

export const defaultTiers: LoyaltyTier[] = [
  {
    id: 'tier-1',
    name: 'Starter',
    minPoints: 0,
    benefits: 'Base earning rate, signup bonus, standard reward catalog',
    sortOrder: 1,
  },
  {
    id: 'tier-2',
    name: 'Pro',
    minPoints: 5000,
    benefits: '1.25x earning rate, free shipping pass eligibility, priority support',
    sortOrder: 2,
  },
  {
    id: 'tier-3',
    name: 'Elite',
    minPoints: 15000,
    benefits: '1.5x earning rate, VIP experiences, dedicated concierge',
    sortOrder: 3,
  },
];
